import cn from 'classnames'
import * as React from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'

import { Card, CardBody } from '../../../../components/card'
import WaveContainer from '../../../../components/wave-container'
import DoodleBackground from '../../../../components/doodle-background'

import styles from './signupForm.module.scss'
import Form from './form'
import Checklist from '../../../../components/checklist'
import { GAEventType } from '../../../../lib/utils'
import { Row, Column } from '../../../../components/layout-row'
import Testimonal from '../../../../components/testimonal'

import josefSkhayri from './josefSkhayri.jpg'
import niclasAhden from './niclasAhden.jpg'
import williamHollingworth from './williamHollingworth.jpg'

const messages = defineMessages({
  heading: {
    id: 'diy-accounting.signup-form.heading',
    defaultMessage: 'Kom igång och bokför nu',
  },
  lede: {
    id: 'diy-accounting.signup-form.lede',
    defaultMessage:
      'Gör som andra smarta företagare och bokför med Dooer. Ingen bindningstid, inget kreditkort, inga begränsningar. Gratis för alltid.',
  },
  free: {
    id: 'diy-accounting.signup-form.free',
    defaultMessage: 'Helt gratis',
  },
  simple: {
    id: 'diy-accounting.signup-form.simple',
    defaultMessage: 'Enkelt att komma igång',
  },
  complete: {
    id: 'diy-accounting.signup-form.complete',
    defaultMessage: 'Enkelt att använda',
  },
  secure: {
    id: 'diy-accounting.signup-form.secure',
    defaultMessage: 'Säkert med BankID',
  },
})

const SignupForm: React.FC<{
  apps?: string[]
  event?: GAEventType
  title?: React.ReactNode
  testimonals?: boolean
  onAfterSubmit?: () => void
}> = ({ apps, event, title, testimonals, onAfterSubmit }) => {
  return (
    <div className={styles.root}>
      <Card className={styles.main}>
        <div className={styles.header}>
          {title || <FormattedMessage tagName="h3" {...messages.heading} />}
          <FormattedMessage tagName="p" {...messages.lede} />
        </div>
        <WaveContainer className={styles.wave}>
          <div style={{ height: '21px' }} />
        </WaveContainer>
        <CardBody>
          <Form apps={apps} event={event} onAfterSubmit={onAfterSubmit} />
        </CardBody>
        <div className={cn(styles.sideWindow, 'visible-lg')}>
          <Checklist
            center
            handwriting
            items={[
              <FormattedMessage key="1" {...messages.free} />,
              <FormattedMessage key="2" {...messages.simple} />,
              <FormattedMessage key="3" {...messages.complete} />,
              <FormattedMessage key="4" {...messages.secure} />,
            ]}
          />
        </div>
      </Card>

      {testimonals && (
        <Row alignItems="start" style={{ marginTop: '10rem' }}>
          <Column>
            <Testimonal
              imgSrc={josefSkhayri}
              jobTitle="Mincykelverkstad"
              name="Josef Skhayri"
              text={`Är grymt imponerad, hur kan allt det här vara gratis?
Det bästa är nog Dooer Fakturering, att kunna skicka fakturor via SMS
med betalinfo är väldigt smidigt.`}
              variant="large"
            />
          </Column>
          <Column>
            <Testimonal
              imgSrc={niclasAhden}
              jobTitle="Instateam"
              name="Niclas Åhdén"
              text="Dooer Fakturering är grymt, gillar starkt den automatiska avprickningen"
              variant="large"
            />
          </Column>
          <Column>
            <Testimonal
              imgSrc={williamHollingworth}
              jobTitle="Hollingworth Digital Consulting"
              name="William Hollingworth"
              text="Väldigt enkelt att skicka fakturor och följa upp. Extra smidigt är att betalda fakturor registreras automatiskt tack vare kopplingen till min bank."
              variant="large"
            />
          </Column>
        </Row>
      )}

      <DoodleBackground className={styles.doodleBackgroundVertical} variant={'topLeft'} />
    </div>
  )
}

export default SignupForm
